import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import LoginFooter from './components/LoginFooter';
import LoginBackground from './components/LoginBackground';

const Login = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  // Check if user is already authenticated
  useEffect(() => {
    if (!loading && user) {
      navigate('/dashboard');
    }
  }, [user, loading, navigate]);

  // Show loading while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-text-muted">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background relative flex items-center justify-center p-4">
      {/* Background Component */}
      <LoginBackground />
      
      {/* Main Content */}
      <div className="relative z-10 w-full max-w-md">
        {/* Login Card */}
        <div className="bg-surface border border-border rounded-2xl shadow-xl p-8 backdrop-blur-sm bg-opacity-95">
          {/* Header Component */}
          <LoginHeader />
          
          {/* Form Component */}
          <LoginForm />
          
          {/* Footer Component */}
          <LoginFooter />
        </div>
      </div>

      {/* Mobile Optimization */}
      <div className="fixed bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-background to-transparent pointer-events-none md:hidden">
        <div className="text-center text-xs text-text-muted">
          Swipe up for better experience
        </div>
      </div>
    </div>
  );
};

export default Login;